/* eslint-disable react/prop-types */
import { useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';

/**
 * ヘルプモーダル共通シェル（バックドロップ + パネル）
 */
export default function HubHelpModalShell({
  isOpen,
  onClose,
  children,
  ariaLabelledBy,
}) {
  useEffect(() => {
    if (!isOpen) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, [isOpen]);

  const handleBackdropClick = useCallback((e) => {
    if (e.target === e.currentTarget) onClose();
  }, [onClose]);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div
      className="hub-help-modal-wrap hub-help-modal-wrap--visible"
      onClick={handleBackdropClick}
      role="presentation"
    >
      <div
        className="hub-help-modal-panel hub-help-modal-panel--visible"
        role="dialog"
        aria-modal="true"
        aria-labelledby={ariaLabelledBy}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    document.body
  );
}
